import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  () => ({
    bottomNavigation: {
      zIndex: 1,
      "& .Mui-selected img": {
        filter: "unset",
      },
      "& img": {
        filter:
          "brightness(0) saturate(100%) invert(53%) sepia(0%) saturate(12%) hue-rotate(267deg) brightness(95%) contrast(91%)",
      },
    },
    svgSelected: {
      filter:
        "brightness(0) saturate(100%) invert(29%) sepia(46%) saturate(2348%) hue-rotate(215deg) brightness(86%) contrast(86%)",
    },
  }),
  { name: "CreatorTool" }
);

export default useStyles;
